import DataTable from 'react-data-table-component';

const CustomerOrderDetail = (props) => {
    const {
        order_id,
        order_date,
        order_items = [],
        sub_total,
        billing_customer_name,
        billing_phone,
        billing_city,
        billing_pincode,
        loading,
        billing_address,
        billing_address_2,
        billing_state,
        billing_country,
    } = props;

    const columns = [
        {
            name: 'S.No',
            selector: (row, index) => index + 1,
            sortable: false,
            width: '70px'
        },
        {
            name: 'Item details',
            selector: row => row.name,
            sortable: false
        },
        {
            name: 'Color',
            selector: row => row.colorName,
            sortable: false
        },
        {
            name: 'Size',
            selector: row => row.sizeName,
            sortable: false
        },
        {
            name: 'Item price',
            selector: row => row.selling_price,
            sortable: false
        },
        {
            name: 'Tax',
            selector: row => row.tax,
            sortable: false
        },
        {
            name: 'Item discount',
            selector: row => row.discount,
            sortable: false
        },
        {
            name: 'Total price',
            selector: row => (
                <div>
                    {row.selling_price}
                </div>
            ),
            sortable: false
        },
    ];

    return (
        <>
            <div className='d-flex align-items-center gap-1 my-3'>
                <h4 className='mb-0'>#{order_id}</h4>
                <span>{`(${order_date})`}</span>
            </div>
            <div className="customer_order_detail_wrapper row">
                <div className="col-8">
                    <div className="">
                        <DataTable
                            columns={columns}
                            data={order_items || []}
                            progressPending={loading}
                            progressComponent={<p>Loading...</p>}
                            // pagination
                            highlightOnHover
                        />
                    </div>
                    <div className='d-flex justify-content-end'>
                        <div className="item_detail_wrapper my-4">
                            <div className="row text-end mb-2">
                                <span className="col-6">Item price</span>
                                <span className="col-6">
                                    {order_items?.reduce((acc, item) => acc + Number(item.selling_price || 0), 0).toFixed(2)}
                                </span>
                            </div>
                            <div className="row text-end mb-2">
                                <span className="col-6">Coupon discount</span>
                                <span className="col-6">
                                    {order_items
                                        .reduce((acc, item) => acc + (item.coupon_discount || 0), 0)}</span>
                            </div>
                            <div className="row text-end mb-2">
                                <span className="col-6">Sub total</span>
                                <span className="col-6">
                                    <span>{(sub_total || 0).toFixed(2)}</span>
                                </span>
                            </div>
                            <div className="row text-end mb-2">
                                <span className="col-6">Delivery fee</span>
                                <span className="col-6">
                                    {order_items
                                        .reduce((acc, item) => acc + (item.delivery_fee || 0), 0)}
                                </span>
                            </div>
                            <div className="row text-end mb-2">
                                <span className="col-6">Total</span>
                                <span className="col-6">
                                    <span>{(sub_total || 0).toFixed(2)}</span>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="col-4">
                    <div className="customer_wrapper">
                        <h6 className="d-flex align-items-center" style={{ gap: '10px' }}>
                            <img src="../images/seller-information.png" alt="" />
                            Shipping address
                        </h6>
                        <div className="d-flex pt-3" style={{ gap: '10px' }} >
                            <div className="customer_detail_wrapper" >
                                <div className="customer_detail_wrapper_box mb-1">
                                    <span className="heading"><b>Name : </b></span>
                                    <span>{billing_customer_name}</span>
                                </div>
                                <div className="customer_detail_wrapper_box mb-1">
                                    <span className="heading"><b>Contact : </b></span>
                                    <span>{billing_phone}</span>
                                </div>
                                <div className="customer_detail_wrapper_box">
                                    <span className="heading"><b>Address : </b></span>
                                    <span>{billing_address} {billing_address_2} {billing_city}, {billing_state}, {billing_country}, {billing_pincode}</span>
                                </div>
                                {/* <div className="customer_detail_wrapper_box">
                                    <span className="heading">Zip Code : </span>
                                    <span>{billing_pincode}</span>
                                </div> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default CustomerOrderDetail